export default "__VITE_ASSET__c158398b__"